export function OutlineUbicacionesIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50357 9.14258C3.4434 9.14258 1.69167 13.877 4.0865 16.5694L5.31991 17.8076L7.50357 20.0009L9.69683 17.8076L10.8343 16.6702C13.3395 13.9922 11.6021 9.14258 7.49877 9.14258H7.50357Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M17.7488 3C15.2724 3 14.2022 5.89155 15.6611 7.5377L16.4146 8.29118L17.7488 9.63017L19.0878 8.29118L19.7837 7.59529C21.3147 5.95874 20.254 3 17.7488 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
